:host {
  display: block;
}

@media screen and (max-width: 979px) {
  .related-products {
    padding: 10px 0 5px;
  }
}

@media screen and (max-width: 979px) {
  .related-products__body {
    box-shadow: 0 4px 4px 0 rgba(51, 51, 51, 0.15);
  }
}

@media screen and (min-width: 980px) {
  .related-products__list {
    display: flex;
    flex-wrap: wrap;
  }
}

.related-products__group {
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  border: 0 solid #e6e6e6;
}

@media screen and (max-width: 979px) {
  .related-products__group {
    border-top-width: 1px;
  }
}

@media screen and (min-width: 980px) {
  .related-products__group {
    display: flex;
    flex-wrap: wrap;
    border-bottom-width: 1px;
  }

  :host(:not([dir="rtl"])) .related-products__group {
    border-right-width: 1px;
  }

  :host([dir="rtl"]) .related-products__group {
    border-left-width: 1px;
  }
}

@media screen and (min-width: 980px) {
  .related-products__group--columns-count-2 {
    width: 50%;
  }
}

@media screen and (min-width: 980px) {
  .related-products__group--columns-count-2:nth-child(-n+2) {
    border-top-width: 1px;
  }
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .related-products__group--columns-count-2:nth-child(2n+1) {
    border-left-width: 1px;
  }

  :host([dir="rtl"]) .related-products__group--columns-count-2:nth-child(2n+1) {
    border-right-width: 1px;
  }
}

@media screen and (min-width: 980px) {
  .related-products__group--columns-count-3 {
    width: 33.3333333333%;
  }
}

@media screen and (min-width: 980px) {
  .related-products__group--columns-count-3:nth-child(-n+3) {
    border-top-width: 1px;
  }
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .related-products__group--columns-count-3:nth-child(3n+1) {
    border-left-width: 1px;
  }

  :host([dir="rtl"]) .related-products__group--columns-count-3:nth-child(3n+1) {
    border-right-width: 1px;
  }
}

@media screen and (min-width: 980px) {
  .related-products__group:hover, .related-products__group:focus {
    z-index: 2;
    box-shadow: 0 4px 4px 0 rgba(51, 51, 51, 0.15);
  }
}